import { Landmark, SlidersHorizontal, Wallet, CreditCard } from 'lucide-react';
import { useCampaignStore, selectSelectedCampaign } from '@/stores/campaignStore';
import { SettingsScopeSection } from './SettingsScopeSection';
import { SettingsNavRow } from './SettingsNavRow';

/**
 * The "This campaign" scope band on the Settings hub. Its contents are scoped to
 * the currently-selected campaign (read from `useCampaignStore`), so the header
 * names that campaign and the section hides entirely when none is selected.
 *
 * Finance points to the existing Finance → Settings surface, which stays where
 * it is. Campaign & Committee, Campaign preferences, and Billing are live
 * sub-pages under the hub.
 */
export function ThisCampaignSection() {
  const campaign = useCampaignStore(selectSelectedCampaign);

  if (!campaign) return null;

  return (
    <SettingsScopeSection title="This campaign" description={campaign.name}>
      <div className="space-y-2">
        <SettingsNavRow
          icon={<Landmark className="h-5 w-5" />}
          label="Campaign & Committee"
          description="Campaign identity and the committee / compliance profile"
          to="/app/settings/campaign-committee"
        />
        <SettingsNavRow
          icon={<SlidersHorizontal className="h-5 w-5" />}
          label="Campaign preferences"
          description="Timezone, voice, canvass questions, and voter data"
          to="/app/settings/campaign-preferences"
        />
        <SettingsNavRow
          icon={<Wallet className="h-5 w-5" />}
          label="Finance"
          description="Banks, processors, and fee rates"
          to="/admin/finance/settings"
        />
        <SettingsNavRow
          icon={<CreditCard className="h-5 w-5" />}
          label="Billing"
          description="Subscription and payment"
          to="/app/settings/billing"
        />
      </div>
    </SettingsScopeSection>
  );
}
